import { supabaseUserMiddleware } from "@/middleware/supabase-user-middleware";
import { queryOptions } from "@tanstack/react-query";
import { createClient } from "./supabase/admin";
import { Status } from "./supabase/enums";
import { createServerFn } from "@tanstack/react-start";

export const websiteConfigQueryOptions = () =>
  queryOptions({
    queryKey: ["website-config"],
    queryFn: () => fetchWebsiteConfig(),
  });

export const fetchWebsiteConfig = createServerFn({ method: "GET" })
  .middleware([supabaseUserMiddleware])
  .handler(async ({ context: { userId, origin, channel } }) => {
    const supabase = createClient();

    const { data, error } = await supabase
      .from("website_configuration")
      .select(
        "id, hero_description, header_color, head_script, logo:image!header_logo_id(url), background_image:image!hero_background_image_id(url), meta_description, meta_title, primary_color, secondary_color, user(companyName:company_name, phone, zipcode:zip_code, streetNumber:street_number, streetName:street_name, lat, lon, city, country)"
      )
      .eq("status", Status.active)
      .eq("user_id", userId)
      .limit(1)
      .single();

    if (error) {
      console.error("Could not fetch website configuration", error);
      throw new Error("Could not fetch website configuration.");
    }

    return {
      id: data.id,
      origin,
      // "storefront" renders the webshop instead of the restaurant menu.
      channel,
      metaTitle: data.meta_title,
      metaDescription: data.meta_description,
      primaryColor: data.primary_color,
      headerColor: data.header_color,
      secondaryColor: data.secondary_color,
      logo: data.logo?.url,
      backgroundImage: data.background_image?.url ?? undefined,
      heroDescription: data.hero_description ?? undefined,
      headScript: data.head_script ?? undefined,
      companyName: data.user.companyName,
      companyPhoneNumber: data.user.phone ?? undefined,
      companyCountry: data.user.country ?? undefined,
      companyAddress: {
        zipCode: data.user.zipcode,
        streetNumber: data.user.streetNumber,
        streetName: data.user.streetName,
        lat: data.user.lat ?? undefined,
        lon: data.user.lon ?? undefined,
        city: data.user.city,
      },
    };
  });

export type WebsiteConfiguration = Awaited<
  ReturnType<typeof fetchWebsiteConfig>
>;
